import { merge, cloneDeep } from 'lodash';
import { formatValue } from '@/views/index/config.js';

const baseOpt = () => {
    const colors = ['#5470C6', '#91CC75', '#ea3d3d'];
    const option = {
        color: colors,
        tooltip: {
            trigger: 'item'
            // axisPointer: {
            //     type: 'cross'
            // }
        },
        dataZoom: [{
            minValueSpan: 5,
            maxValueSpan: 5,
            type: 'inside',
            xAxisIndex: [0, 1, 2] // 表示这个 dataZoom 组件控制 第一个 和 第三个 yAxis
        }],
        grid: {
            right: 20,
            left: 10,
            bottom: 0,
            top: 40,
            containLabel: true
        },
        legend: {},
        xAxis:
            {
                type: 'category'
            },
        yAxis:
            {
                type: 'value',
                name: '标题'
            },
        series:
            {
                type: 'bar',
                barMaxWidth: 20,
                // yAxisIndex: 1,
                showBackground: false,
                label: {
                    show: true,
                    formatter: '{c}',
                    color: '#ffffff'
                },
                itemStyle: {
                    // borderRadius: 100
                },
                data: [0, 0, 0, 0, 0]
            }
    };
    return option;
};

// eslint-disable-next-line max-lines-per-function
export const testBar = (data) => {
    const { series, xAxis } = data;
    const option = {
        legend: {
            type: 'plain',
            itemWidth: 8,
            itemHeight: 2,
            icon: 'roundRect',
            textStyle: {
                color: '#333333',
                fontSize: 12
            }
        },
        color: ['#329DFF', '#F8D30D', '#FF6F72'],
        tooltip: {
            trigger: 'axis',
            formatter: (params) => {
                const _text = params.map((el, index) => {
                    // return `${params[index].seriesName}: ${params[index].value}<br/>`;
                    return `<span style="display:flex;justify-content: space-between;">
                                        <span><span style="display:inline-block;margin-right:6px;width:8px;height:8px;background:${el.color};border-radius:100%;"></span>${el.seriesName}</span>
                                        <span style="margin-left:20px;font-weight:500;">${formatValue(el.value) || '--'}${index === 4 ? '%' : ''}</span>
                                    </span>`;
                }).join('');

                return `${params[0].name}<br/>${_text}`;
            },
            valueFormatter: (value, dataIndex) => {
                return formatValue(value) || '--';
            }
        },
        xAxis: [
            {
                type: 'category',
                data: xAxis,
                axisLabel: { interval: 0, rotate: 45 }
            }
        ],
        yAxis: [ {
            type: 'value',
            name: '',
            min: 0,
            position: 'left'
        },
        {
            type: 'value',
            name: '',
            min: 0,
            position: 'right',
            axisLabel: {
                formatter: '{value}%'
            }

        }],
        series: series.map(item => ({
            ...item,
            // tooltip: {
            //     valueFormatter: function (value) {
            //         return value;
            //     }
            // },
            itemStyle: {
                normal: {
                    barBorderRadius: 5
                }
            }
        }))
    };
    return merge({}, cloneDeep(baseOpt()), option);
};
